/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the online editor from the homepage. Choose Blank workbook or one of the three samples: Sales dashboard, Monthly budget or Grade tracker. A sample gives you meaningful data to inspect immediately; a blank workbook is better when you want to enter a small example of your own.`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从首页打开在线编辑器，选择空白工作簿，或销售看板、月度预算、成绩跟踪三个示例之一。示例能让你立即检查有意义的数据；如果想输入自己的小例子，则可以使用空白工作簿。`)
};

/**
* | output |
* | --- |
* | "Open the online editor from the homepage. Choose Blank workbook or one of the three samples: Sales dashboard, Monthly budget or Grade tracker. A sample gives..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.0.paragraphs.0" }